import script from "./ApartmentItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApartmentItem.vue?vue&type=script&setup=true&lang=ts"

import "./ApartmentItem.vue?vue&type=style&index=0&id=48898b16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48898b16"]])

export default __exports__